module.exports = __webpack_public_path__ + "static/media/34.12d457c3.png";